import { render, staticRenderFns } from "./IncidentCard.vue?vue&type=template&id=5a2ed6e4&scoped=true"
import script from "./IncidentCard.vue?vue&type=script&lang=js"
export * from "./IncidentCard.vue?vue&type=script&lang=js"
import style0 from "./IncidentCard.vue?vue&type=style&index=0&id=5a2ed6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ed6e4",
  null
  
)

export default component.exports